export enum ProgrammeFrequency {
    Daily = "Daily",
    Weekly = "Weekly",
    Fortnightly = "Fortnightly",
    Monthly = "Monthly",
}
